<script lang="ts">
    import { createEventDispatcher } from 'svelte';
    import { fade } from 'svelte/transition';
    import type ChallengePoint from '../Model/ChallengePoint';
    import Challenge from './Challenge.svelte';
    import Modal from './Modal.svelte';
    import TopBar from './TopBar.svelte';

    export let challenge: ChallengePoint;

    const dispatch = createEventDispatcher();

    let inIntro: boolean = true;
    let inChallenge: boolean = false;

    function onBack() {
        dispatch('close');
    }

    function onStartClick() {
        inIntro = false;
        inChallenge = true;
    }

</script>

<style lang="scss">

    @use '../mixins';
    @use '../variables';

    .modal-content {
        position: relative;
        z-index: var(--zIndex, 1);
        height: 100%;
        display: flex;
        flex-direction: column;
    }

    .content {
        flex: 1 1 0;
        background-color: var(--route-color, --color-primary);
        box-shadow: 0 7px 5px -5px rgb(0 0 0 / 40%) inset;
        position: relative;
    }

    .panel {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        box-sizing: border-box;
    }

    .intro {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-evenly;
        
        .circle {
            width: 60%;
            max-width: 300px;
            background-color: white;
            border-radius: 50%;
            position: relative;

            &::before {
                content: '';
                display: block;
                padding-top: 100%;
            }

            .trivial-saludable,
            .manzanita-challenge {
                position: absolute;
                left: 50%;
                transform: translateX(-50%);
            }

            .trivial-saludable {
                width: 150%;
                top: -13.3%;
            }

            .manzanita-challenge {
                width: 93.3%;
                top: 44.6%;
            }
        }

    }

    .start-btn {
        @include mixins.big-btn;
    }

    .challenge {
        padding: 4rem 2rem;
        display: flex;
        flex-direction: column;
    }

    .challenge-innner {
        flex: 1 1 0;
    }

    @media (max-width: variables.$big-phone-width) {

        .challenge {
            padding: 2.5rem 1rem;
        }

    }

</style>

<Modal>
    <div class="modal-content">
        <TopBar title="Trivial saludable" on:back={onBack} />
        <div class="content">
            
            {#if inIntro}
            <div class="panel intro" transition:fade>
                
                <div class="circle">
                    <img class="trivial-saludable" src="/images/trivial-saludable.png" alt="">
                    <img class="manzanita-challenge" src="/images/manzanita-challenge.png" alt="">
                </div>

                <button class="start-btn" type="button" on:click={onStartClick}>Comenzar</button>

            </div>
            {/if}

            {#if inChallenge}
            <div class="panel challenge" transition:fade>
                <div class="challenge-innner">
                    <Challenge {challenge} on:success on:fail />
                </div>
            </div>
            {/if}

        </div>
    </div>
</Modal>
